import { useMutation } from '@tanstack/react-query';

import type {
  FiscalOnlineRegistrarFormData,
  FiscalOnlineRegistrarFormResponse,
  FiscalOnlineXReportResponse,
  FiscalOnlineZReportResponse,
  SetCashierData,
  ToggleRegistrarModeResponse,
  ToggleVatModeResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useFiscalOnlineRegistrarFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: FiscalOnlineRegistrarFormData;
    }) =>
      HttpClient.request<FiscalOnlineRegistrarFormResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });

export const useFiscalOnlineSetCashierMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: SetCashierData }) =>
      HttpClient.request<FiscalOnlineRegistrarFormResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });

export const useFiscalOnlineOpenShiftMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<FiscalOnlineRegistrarFormResponse>({
        method: 'POST',
        url,
      }),
  });

export const useFiscalOnlineCloseShiftMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<FiscalOnlineZReportResponse>({
        method: 'POST',
        url,
      }),
  });

export const useFiscalOnlineGenerateXReportMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<FiscalOnlineXReportResponse>({
        method: 'POST',
        url,
      }),
  });

export const useToggleRegistrarModeMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<ToggleRegistrarModeResponse>({
        method: 'POST',
        url,
      }),
  });

export const useToggleVatModeMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<ToggleVatModeResponse>({
        method: 'POST',
        url,
      }),
  });
